export const CREDENTIALS_HEADERS = [
  {
    key: 'name',
    label: 'Name',
    type: 'name',
  },
  {
    key: 'key',
    label: 'Token',
    type: 'token',
  },
  {
    key: 'lastUsedAt',
    label: 'Last used',
    type: 'date',
  },
  {
    key: 'createdAt',
    label: 'Created',
    type: 'date',
  },
  {
    key: 'status',
    label: 'Status',
    type: 'status',
  },
  {
    key: 'Actions',
    label: 'Actions',
    type: 'actions',
  },
]
